/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable max-len */
import React from "react";
import { connect } from "react-redux";
import { DispatchFunc } from "../../../../store/ActionTypes";
import { ReduxState, isRemoteLoading } from "../../../../store/ReduxState";
import { remoteTrigger } from "../../../../store/RemoteActions";
import { RemoteScope } from "../../../../store/RemoteTypes";
import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import { InitType } from "../../../../store/Init/Types";
import { Form } from "./MaxLeaseLoan/Form";
import { FormMaxLeaseLoanObject, FormMaxLeaseLoanObjectResponse } from "../../../../store/MaxLeaseLoan/Types";
import { ThemePalette, ThemePaletteState } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/theme";
import { Link, LinkTarget } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/05-atoms/Link";
import { Hr } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/05-atoms";
import { RTE } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/components/core/07-organisms";
import { getCurrentEnv } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/utils";

interface OwnProps {
    asPage: boolean;
    routeProps?: string;
}

interface StateProps {
    init: InitType;
    loading: boolean;
    resultMaxLease?: FormMaxLeaseLoanObjectResponse;
    resultMaxLoan?: FormMaxLeaseLoanObjectResponse;
    submitLoadingMaxLease: boolean;
    submitLoadingMaxLoan: boolean;
}

/**
 *
 */
interface DispatchProps {
    triggerInit: (route: string, channel: string) => void;
    onChangeMaxLeaseFormFields: (body: FormMaxLeaseLoanObject, channel: string) => void;
    onChangeMaxLoanFormFields: (body: FormMaxLeaseLoanObject, channel: string) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

/**
 *
 * @param s
 */
const mapStateToProps = (s: ReduxState): StateProps => ({
    init: s.prop("remote").prop(RemoteScope.INIT) as InitType,
    loading: isRemoteLoading(s, RemoteScope.INIT),
    resultMaxLease: s.prop("remote").prop(RemoteScope.MAX_LEASE_POST),
    resultMaxLoan: s.prop("remote").prop(RemoteScope.MAX_LOAN_POST),
    submitLoadingMaxLease: isRemoteLoading(s, RemoteScope.MAX_LEASE_POST),
    submitLoadingMaxLoan: isRemoteLoading(s, RemoteScope.MAX_LOAN_POST),
});


/**
 *
 */
const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    triggerInit: (route: string, channel: string) => dispatch(remoteTrigger(RemoteScope.INIT, {route, channel})),
    onChangeMaxLeaseFormFields: (body, channel: string) =>
        dispatch(remoteTrigger(RemoteScope.MAX_LEASE_POST, {form: body, channel})),
    onChangeMaxLoanFormFields: (body, channel: string) =>
        dispatch(remoteTrigger(RemoteScope.MAX_LOAN_POST, {form: body, channel})),
});

class InitComp
    extends React.Component<Props, {}> {

    public constructor(props: Props) {
        super(props);
        this.getDutchLeaseImage = this.getDutchLeaseImage.bind(this);
        this.sendAmountOnChange = this.sendAmountOnChange.bind(this);
    }

    public componentDidMount(): void {
        const url = new URL(window.location.href);
        const channel = url.searchParams.get("channel");
        const hasCalcType = this.props.routeProps === "max-lease" || this.props.routeProps === "max-loan";
        if(this.props.init === undefined && channel !== null && hasCalcType) {
            this.props.triggerInit(this.props.routeProps ?? "", channel ?? "");
        }
    }

    public componentDidUpdate(prevProps: Props) {
        if((prevProps.resultMaxLease !== this.props.resultMaxLease) || (prevProps.resultMaxLoan !== this.props.resultMaxLoan)) {
            this.sendAmountOnChange();
        }
    }

    public render() {
        const url = new URL(window.location.href);
        const hasErrorOf = !url.searchParams.get("channel") ? "channel" : (this.props.routeProps === "max-lease" || this.props.routeProps === "max-loan") ? undefined : "calcType";
        return (
            <Mary.base.BaseConsumer>
                { ({getTheme}) => (
                    <Mary.base.Container
                        theme={{
                            shadow: this.props.asPage ? Mary.theme.ThemeShadowSizes.SMALL : undefined,
                            palette: this.props.asPage ? Mary.theme.ThemePalette.CONTRAST_PRIMARY : undefined,
                            padding: {
                                "": { y: 3 },
                                "sm": { y: 4 },
                            },
                        }}
                    >
                        {!hasErrorOf ? (
                            <div style={{ minHeight: "300px", position: "relative" }}>
                                {this.props.init && !this.props.loading && (
                                    <>
                                        {getTheme() !== Mary.theme.Themes.MOBILIST && (
                                            <>
                                                {this.props.init.image && (
                                                    <div
                                                        style={{
                                                            border: `3px solid ${getTheme() === Mary.theme.Themes.DUTCHLEASE ? "white" : "black"}`,
                                                            marginBottom: "15px",
                                                            padding: "1px",
                                                            display: "flex",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <img
                                                            src={getTheme() === Mary.theme.Themes.DUTCHLEASE ? this.getDutchLeaseImage() : this.props.init.image}
                                                            alt={getTheme() === Mary.theme.Themes.DUTCHLEASE ? "Dutch lease image" : "Image"}
                                                            height={50}
                                                        />
                                                    </div>
                                                )}
                                                <div style={{ marginBottom: "15px" }}>
                                                    <Mary.atoms.Heading
                                                        level={Mary.atoms.Headings.H1}
                                                        headingStyle={Mary.atoms.Headings.H3}
                                                    >
                                                        {this.props.init?.title ?? ""}
                                                    </Mary.atoms.Heading>
                                                </div>
                                                <div style={{ marginBottom: "10px" }}>
                                                    <Mary.organisms.RTE content={this.props.init?.description ?? ""} />
                                                </div>
                                            </>
                                        )}
                                        <Form
                                            init={this.props.init}
                                            onChangeCallAPI={this.props.routeProps === "max-lease" ? this.props.onChangeMaxLeaseFormFields : this.props.onChangeMaxLoanFormFields}
                                            result={this.props.routeProps === "max-lease" ? this.props.resultMaxLease : this.props.resultMaxLoan}
                                            submitLoading={this.props.routeProps === "max-lease" ? this.props.submitLoadingMaxLease : this.props.submitLoadingMaxLoan}
                                        />
                                    </>
                                )}
                                {this.props.loading && (
                                    <Mary.atoms.loadingindicator.LoadingIndicator
                                        type={Mary.atoms.loadingindicator.LoadingIndications.DEFAULT}
                                        theme={{ palette: Mary.theme.ThemePalette.BRAND_PRIMARY }}
                                    />
                                )}
                            </div>
                        ) : (
                            <>
                                <Mary.atoms.Blockquote theme={{ paletteState: ThemePaletteState.WARNING }}>
                                    <h4>{hasErrorOf === "channel" ? "Kanaal ontbreekt" : "Onbekend formulier opgevraagd"}</h4>
                                    <br />
                                    <div className="scl-h-text">
                                        {hasErrorOf === "channel" ? "U heeft geen kanaal opgegeven." : "Het formulier dat u probeert op te vragen is niet bekend."}
                                    </div>
                                </Mary.atoms.Blockquote>
                                {getCurrentEnv() === "local" && (
                                    <>
                                        <Hr />
                                        <RTE>
                                            <p>Problemen met het formulier? Bezoek de <Link link={{target: LinkTarget.BLANK, href: `${window.location.origin}/setup`}} theme={{palette: ThemePalette.BRAND_ACCENT}} ><b>Setup wizard</b></Link> van Team Claude voor de juiste configuratie.</p>
                                        </RTE>
                                    </>)}
                            </>
                        )}
                    </Mary.base.Container>
                )}
            </Mary.base.BaseConsumer>
        );
    }

    private sendAmountOnChange() {
        const calcType = this.props.routeProps;
        const amount = calcType === "max-lease" ? this.props.resultMaxLease?.totalAmountValue : this.props.resultMaxLoan?.totalAmountValue;
        window.parent.postMessage(
            {
                type: `claude:scalc:${calcType ?? ""}:amount`,
                data: {
                    amount: amount,
                },
            },
            "*",
        );
    }

    private getDutchLeaseImage() {
        return "data:image/svg+xml;base64,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";
    }
}

export const Init = connect(
    mapStateToProps,
    mapDispatchToProps,
)(InitComp);
